// extracted by mini-css-extract-plugin
export default {"banner":"jo2Pi","image":"Z54iv","cnImage":"WKgtb","content":"BN6r8","title":"pKaSw","text":"eJWJP","link":"LXIgU"};